import { useState, useEffect } from "react";
import axios from "axios";
import { api_v3_list_of_clans } from "../../../utils/constants";

const useClanInfo = (player) => {
  const [clanInfo, setClanInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadClanInfo = async () => {
      setLoading(true);
      try {
        const response = await axios.get(api_v3_list_of_clans());
        if (response.status === 200) {
          const clansList = response.data;
          const playerClan = clansList.find(
            (clan) => clan.clanId === player.clanId
          );
          setClanInfo(playerClan);
          setError(false);
        } else {
          console.error(
            `Error fetching clans: ${response.status}`,
            response.data
          );
          setError(true);
        }
      } catch (error) {
        console.error("Error fetching clans:", error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    if (player) {
      loadClanInfo();
    }
  }, [player]);

  return { clanInfo, loading, error };
};

export default useClanInfo;
